import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { getCurrentUser } from "@aws-amplify/auth";

import { useAppNavigate } from "./useAppNavigate";
import FullPageLoader from "component/common/FullPageLoader";

const UnAuthGuard = () => {
  const [checking, setChecking] = useState(true);
  const { authenticatedNavigate } = useAppNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          authenticatedNavigate.root();
        }
      } catch (err) {
      } finally {
        setChecking(false);
      }
    };
    checkAuth();
  }, [authenticatedNavigate]);

  if (checking) return <FullPageLoader />;

  return <Outlet />;
};

export default UnAuthGuard;
